import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";

const ActualizarHistorialPagosCotizaciones = async ({idCotizacion, idPago, tipoEvento, idUsuario, detalles}) => {
  try {
    const response = await axios.get(`${BACKEND}/api/cotizaciones/${idCotizacion}`, {withCredentials: true});

    const responseIp = await axios.get("https://api.ipify.org?format=json")
    const userIp = responseIp?.data?.ip

    const historial = response.data.historialCambiosPagos || [];

    const nuevoHistorial = [
      ...historial.map((h) => ({
        ...h,
        usuario: h.usuario.id
      })),
      {
        usuario: idUsuario,
        idPago: idPago,
        tipoEvento: tipoEvento,
        fecha: new Date().toISOString(),
        detalles: detalles,
        userIp: userIp
      }
    ];

    await axios.put(`${BACKEND}/api/cotizaciones/${idCotizacion}`, {
      historialCambiosPagos: nuevoHistorial,
    }, {withCredentials: true});

    } catch (error) {
      toast.error("Error al actualizar el historial de pagos de la cotización: " + error);
    }
}

export default ActualizarHistorialPagosCotizaciones;
